import styled from 'styled-components';

export const NavHeader = styled.nav`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  background-color: white;
  padding-block: 8px;
  padding-inline: 4px;
  position: relative;
  min-height: 56px;

  .left {
    display: flex;
    align-items: center;
    gap: 1rem;

    button.menu {
      border: none;
      display: grid;
      place-items: center;
      width: 42px;
      height: 42px;
      padding: 0;
      font-size: 28px;
      border-radius: 10px;
      background-color: transparent;
      color: #495057;
      cursor: pointer;
      transition:
        background-color 0.18s ease,
        color 0.18s ease,
        transform 0.12s ease;
    }

    button.menu:hover {
      color: #007cf0;
      background-color: #f0f7ff;
    }

    button.menu:active {
      color: #007cf0;
      background-color: #dbeeff;
      transform: scale(0.92);
    }

    button.menu:focus-visible {
      outline: 2px solid #91d5ff;
      outline-offset: 2px;
    }

    .logo-container {
      display: flex;
      align-items: center;
      gap: 0.5rem;

      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        object-position: center;
      }

      .title-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        gap: 1px;
        /* asymmetric padding drops the block off the bar's top edge */
        padding-block: 5px 2px;

        /* Property name — bright single-family sky gradient (brand #1e9df1).
           Enterprise-restrained: one hue family, brighter at the center,
           barely-there drift. Truncates gracefully for long hotel names. */
        p.title {
          font-size: 1.3rem;
          font-weight: 700;
          line-height: 1.15;
          background: linear-gradient(
            100deg,
            #0b7fd6 0%,
            #1e9df1 40%,
            #43b6ff 65%,
            #0b7fd6 100%
          );
          background-size: 300% 100%;
          background-clip: text;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          filter: drop-shadow(0 1px 5px rgba(30, 157, 241, 0.28));
          letter-spacing: 0.4px;
          margin-bottom: 0;
          white-space: nowrap;
          max-width: min(42vw, 360px);
          overflow: hidden;
          text-overflow: ellipsis;
          animation: title-aurora 45s ease-in-out infinite;
        }

        /* Tiny drift (0% → 12%) over 45s — perceptible only if you stare. */
        @keyframes title-aurora {
          0%,
          100% {
            background-position: 0% 50%;
          }
          50% {
            background-position: 12% 50%;
          }
        }

        @media (prefers-reduced-motion: reduce) {
          p.title {
            animation: none;
          }
        }
      }
    }

    /* xl */
    @media (min-width: 1280px) {
      button.menu {
        display: none;
      }
    }
  }

  ul.unshow {
    display: none;
  }

  button.toggle-show {
    position: absolute;
    right: 10px;
    top: 10px;
    font-size: 1.3rem;
    display: grid;
    place-items: center;
    width: 40px;
    height: 40px;
    border: none;
    border-radius: 5px;
    background-color: transparent;
  }

  button.toggle-show:active {
    color: #007cf0;
    background-color: #dee2e6;
  }

  ul.nav-buttons {
    padding-right: 4px;
    flex-wrap: nowrap;
  }

  /* md */
  /* @media (min-width: 768px) {
  } */

  @media (min-width: 900px) {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding-block: 0;
    min-height: 56px;

    .left {
      display: flex;
      align-items: center;
      height: 56px;

      .logo-container {
        > div:first-child {
          width: 40px;
          height: 40px;
        }

        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
          object-position: center;
        }

        p.title {
          font-size: 1.15rem;
        }
      }
    }

    ul.nav-buttons {
      display: flex;
    }

    ul.nav-buttons .hidden {
      display: flex;
    }

    button.toggle-show {
      display: none !important;
    }
  }

  @media (min-width: 1024px) {
  }
`;
